import { Transaction } from '../types/budget';
import Papa from 'papaparse';
import i18n from '../i18n';

/**
 * Properly escape a CSV field value
 * If the value contains commas, quotes, or newlines, wrap it in quotes and escape any quotes
 */
export const escapeCSVField = (value: string | number): string => {
  if (typeof value === 'number') return value.toString();

  const needsQuotes = value.includes(',') || value.includes('"') || value.includes('\n');
  if (!needsQuotes) return value;

  // Replace any quotes with double quotes (CSV standard for escaping quotes)
  const escapedValue = value.replace(/"/g, '""');
  return `"${escapedValue}"`;
};

/**
 * Export transactions to CSV format using PapaParse
 */
export const exportToCSV = (transactions: Transaction[]): string => {
  // Get the translated version of "common" in current language
  const commonTranslated = i18n.t('defaults.responsibles.common');

  const csvData = transactions.map((transaction) => ({
    category: transaction.category,
    responsible: transaction.responsible === 'common' ? commonTranslated : transaction.responsible,
    description: transaction.description,
    destination: transaction.destination,
    amount: transaction.amount,
  }));

  return Papa.unparse(csvData);
};

/**
 * Download transactions as a CSV file
 */
export const downloadCSV = (transactions: Transaction[], budgetName: string): void => {
  // Get the CSV content
  const csvContent = exportToCSV(transactions);

  // Create a Blob with the CSV content
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

  // Create a download link
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `${budgetName}.csv`;

  // Trigger the download
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
